import { Draft } from '@reduxjs/toolkit';
import { PrivateAssetResult } from '@ff-os/shared-utils/types/private-assets/PrivateAssetResult';
import { Size } from '@ff-os/shared-utils/types/Size';
import { GiftJson } from '@ff-scene-plugins/gift-shared/GiftJson';
import { PhotoVariableInput } from '@gift-variable-plugins/photo-shared/PhotoVariableInput';
import { PhotoUploadData } from './PhotoUploadData';

export const handleSuccess = (
    input: Draft<GiftJson.Input<PhotoVariableInput>>,
    requestMeta: PhotoUploadData,
    result: PrivateAssetResult<Size>
) => {

    if (input.value.cuid !== requestMeta.cuid) {
        return;
    }

    input.value.status = 'saved';
    input.value.assetUrl = result.url;

    const { width, height } = result.meta;

    if (!requestMeta.temporaryUrl) {

        input.value.imageWidth = width;
        input.value.imageHeight = height;
        input.value.cropBox!.width = width;
        input.value.cropBox!.height = height;

    } else if (width === input.value.imageHeight && height === input.value.imageWidth) {

        // Fix images with xmp tag orientations 5 - 8 #17453

        input.value.imageWidth = width;
        input.value.imageHeight = height;
        input.value.cropBox!.x = 0;
        input.value.cropBox!.y = 0;
        input.value.cropBox!.width = width;
        input.value.cropBox!.height = height;
    }
};